import React, { Fragment, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import styles from 'styles/carousel.module.scss';
import { Button } from 'components';
import useReactRouter from 'use-react-router';
import EmbeddedContext from 'context/EmbeddedContext';
import { History } from '@shopify/app-bridge/actions';

const Carousel = ({
	active = null,
	contents,
	controls,
	controlsPosition = 'both',
	onChange = null,
	type = 'carousel',
}) => {
	const { location } = useReactRouter();
	let params = new URLSearchParams(location.search);
	const { AppBridgeHistory } = useContext(EmbeddedContext);
	const ACTIVE_IS_NOT_SET = active === null;
	const [activeTab, setActiveTab] = useState(ACTIVE_IS_NOT_SET ? parseInt(params.get('activeTab')) || 0 : active);
	const bindedSetActiveTab = (tab) => {
		if (onChange) onChange(tab);
		setActiveTab(tab);
	};

	useEffect(() => {
		if (ACTIVE_IS_NOT_SET)
			AppBridgeHistory.dispatch(History.Action.REPLACE, `${location.pathname}?activeTab=${activeTab}`);
	}, [activeTab]);

	return (
		<div className={styles.carousel}>
			{['top', 'both'].includes(controlsPosition) && (
				<Fragment>
					{type === 'carousel' ? (
						<CarouselControls {...{ controls, activeTab, setActiveTab }} />
					) : (
						<StepperControls {...{ controls, activeTab, setActiveTab }} />
					)}

					<hr />
				</Fragment>
			)}
			<div className={styles.content}>
				{contents.map((content, index) => {
					let isFunction = typeof content === 'function';
					return index === activeTab ? (
						<Fragment key={`content-${index}`}>
							{isFunction ? content(bindedSetActiveTab) : content}
						</Fragment>
					) : null;
				})}
			</div>
			{['bottom', 'both'].includes(controlsPosition) && (
				<Fragment>
					<hr />
					<CarouselControls {...{ controls, activeTab, setActiveTab }} />
				</Fragment>
			)}
		</div>
	);
};

const CarouselControls = ({ controls, activeTab, setActiveTab }) => {
	return (
		<div className={styles.control}>
			{controls.map(
				(control, index) =>
					control.current === activeTab && (
						<Button
							// loading={true}
							key={`control-${index}`}
							{...control}
							onClick={() => {
								if (typeof control.next === 'function') control.next(setActiveTab);
								else if (Number.isInteger(control.next)) setActiveTab(control.next);
							}}
						/>
					)
			)}
		</div>
	);
};

const StepperControls = ({ controls, activeTab, setActiveTab }) => {
	return (
		<div className={styles.stepperControls}>
			{controls.map((control, index) => (
				<div
					className={`${control.current === activeTab ? styles.active : ''}`}
					key={`control-${index}`}
					{...control}
					onClick={() => {
						if (typeof control.next === 'function') control.next(setActiveTab);
						else if (Number.isInteger(control.next)) setActiveTab(control.next);
					}}
				>
					{control.text}
				</div>
			))}
		</div>
	);
};

Carousel.propTypes = {
	contents: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.func])).isRequired,
	controls: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			current: PropTypes.number.isRequired,
		})
	).isRequired,
};
export default Carousel;
